import "../../CommonImports";
import "../../Core/core.css";
import "./Spinner.css";
import * as React from "react";
import { css } from '../../Util';
export var Spinner = function (props) {
    var ariaLabel = props.ariaLabel, ariaLive = props.ariaLive, className = props.className, label = props.label, _a = props.size, size = _a === void 0 ? "medium" /* medium */ : _a;
    return (React.createElement("div", { className: css(className, "bolt-spinner flex-column"), "aria-label": ariaLabel, "aria-live": ariaLive },
        React.createElement("div", { className: css("bolt-spinner-circle", size) }),
        label && React.createElement("div", { className: "bolt-spinner-label" }, label)));
};
// TODO: Remove if we fix Jest issue
Spinner.displayName = "Spinner";
